<template>
  <div class="policy-page">
    <h1>Privacy Policy</h1>
    <div class="policy-content">
      <p class="last-updated">Last updated: 6 May 2025</p>
      <p>This Privacy Policy explains how we collect, use, and protect your personal information when you visit or interact with our platform.</p>
      <section>
        <h2>Information we collect</h2>
        <ul>
          <li>Personal data such as name, email address, shipping address, and phone number</li>
          <li>Browsing information (cookies, IP address, device type, usage behavior)</li>
          <li>Payment details (processed securely via third-party platforms like Stripe or PayPal)</li>
        </ul>
      </section>
      <section>
        <h2>How we use your information</h2>
        <ul>
          <li>To process and fulfill your orders</li>
          <li>To send you order-related communications</li>
          <li>To improve and personalize your user experience</li>
          <li>To comply with legal and security requirements</li>
        </ul>
      </section>
      <section>
        <h2>We may share your data with</h2>
        <ul>
          <li>Secure payment providers</li>
          <li>Logistics or verification services (only if related to your purchase)</li>
          <li>We never sell or rent your personal data</li>
        </ul>
      </section>
      <section>
        <h2>Your rights</h2>
        <p>You may access, modify, or delete your personal data at any time by contacting us at:<br>
        <a href="mailto:info@curatoreden.com">info@curatoreden.com</a></p>
      </section>
      <section>
        <h2>Cookies</h2>
        <p>We use cookies to improve site performance and your browsing experience. You can disable cookies through your browser settings.</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  metaInfo: {
    title: 'Privacy Policy'
  }
}
</script>

<style scoped>
.policy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 24px;
  color: #333;
}

.last-updated {
  font-size: 1rem;
  color: #444;
  margin-bottom: 1.5rem;
}

.policy-content {
  line-height: 1.6;
}

section {
  margin-bottom: 24px;
}

h2 {
  font-size: 1.2rem;
  color: #444;
  margin-bottom: 10px;
}

ul {
  margin-left: 1.5rem;
  margin-bottom: 1rem;
}

li {
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 1rem;
}

p {
  color: #666;
  margin-bottom: 15px;
}

a {
  color: #007bff;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .policy-page {
    padding: 20px;
  }
  h1 {
    font-size: 2rem;
    margin-bottom: 18px;
  }
  h2 {
    font-size: 1.05rem;
  }
}
</style> 